import { patientRequestsTyped } from "@/api/(requests)/patientTyped";
import type { ProfileUpdatePayload } from "@/core/types";

export async function updateMemberProfile(data: ProfileUpdatePayload) {
  return patientRequestsTyped.update_profile({ context: { showLoader: false }, data });
}
